<isc-loader />

<!-- @if (isLoggedIn()) {

  <isc-layout>
    <router-outlet />
  </isc-layout>

} @else {

  <router-outlet />

} -->

<!-- app.html -->
<!-- The router will automatically decide whether to load the Auth pages 
     or the Layout + Dashboard based on your app.routes.ts logic -->
<div
  class="h-full w-full"
  [class.pointer-events-none]="subscriptionAccess.blocked()"
  [class.select-none]="subscriptionAccess.blocked()"
>

  <router-outlet />
<isc-upload-widget />
</div>

<isc-pwa-update-notification />